(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyCustomerFormDataReportSearch', CompanyCustomerFormDataReportSearch);

    CompanyCustomerFormDataReportSearch.$inject = ['$resource', 'ENV'];

    function CompanyCustomerFormDataReportSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/company-customer-form-data-report/:id';


        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
